import { ICompareInChart } from "@/api";
import { MetadataChip } from "@/components/shared/chips/MetadataChip";
import { theme } from "@/config/project";
import { Box } from "@mui/material";
import { BookCheck, FileSearch2 } from "lucide-react";

interface IProps {
    comparison: ICompareInChart;
}

export const PageHeaderLeftContent = ({ comparison }: IProps) => {
    return (
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-end" }}>
            <Box>
                <Box
                    sx={{
                        fontSize: "0.65rem",
                        color: theme.palette.text.secondary,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.025em",
                        mb: 0.25,
                    }}
                >
                    Scopes
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {comparison.scopes.map((scope) => (
                        <MetadataChip
                            key={scope.id}
                            icon={<FileSearch2 />}
                            label={scope.document_title}
                            backgroundColor={theme.palette.tertiary.main}
                            color={theme.palette.primary.main}
                            hoverBackgroundColor={theme.palette.primary.main}
                            href={`/organizations/scopes/${scope.id}`}
                        />
                    ))}
                </Box>
            </Box>
            <Box>
                <Box
                    sx={{
                        fontSize: "0.65rem",
                        color: theme.palette.text.secondary,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.025em",
                        mb: 0.25,
                    }}
                >
                    Checklist
                </Box>
                <MetadataChip
                    icon={<BookCheck />}
                    label={comparison.clause_checklist.name}
                    backgroundColor={theme.palette.successLight.main}
                    color={theme.palette.success.main}
                    hoverBackgroundColor={theme.palette.success.main}
                    href={`/organizations/checklists/${comparison.clause_checklist_id}`}
                />
            </Box>
        </Box>
    );
};
